module.exports = "/matchcenter-staging/assets/images/logo_matchcenter.ca0ef8dc8edcf4cfe454a8162287a493.svg";